import { GET_LCR_COUNTS, GET_LCR_DATA, GET_LCR_SALESPERSONS } from './types'

const initialState = {
  data: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LCR_COUNTS:
      return {
        ...state,
        counts: action.payload,
      }
    case GET_LCR_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case GET_LCR_SALESPERSONS:
      return {
        ...state,
        salespersons: action.payload,
      }
    default:
      return state
  }
}
